module.exports = {
	"articleTitle1": "After year on international stage, a tougher Murillo returns to Michigan",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "U-M Soccer Stadium",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/soccer/goal-barrage-leads-wolverines-past-grizzlies",
	"articleSnippet1": "Aug 20, 2015 ... Christina Murillo controls the ball in a 2013 game at U-M Soccer Stadium. Murillo \nplayed for the Mexican Women's National Team in the World ...",
	"articleSnippet2": "Oct 25, 2016 ... The Michigan men's soccer team cruised to a 5-1 win on Tuesday at U-M Soccer \nStadium. Claire Meingast/Daily. Mark Calcagno. For the Daily.",
	"totalMisc": 0,
	"articleTitle2": "Goal barrage leads Wolverines past Grizzlies ",
	"address": "2250 S State St. Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160412/Marina5.online.jpg?itok=lC6gAB0w",
			"author": "Marina Ross",
			"caption": "Members of Michigan’s soccer team celebrate a goal made against Michigan State on October 31, 2015."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/150909/amf.SCW_.vsMarquette.8.23.15.0122.jpg?itok=n0TSORqz",
			"author": "Allison Farrand",
			"caption": "The Wolverines plan to finish off opportunities against Central Michigan."
		}
	],
	"position": {
		"lat": 42.252739,
		"lng": -83.746773
	},
	"tips": [],
	"bathroomrating": [],
	"categories": {
		"misc": 1,
		"location": 1,
		"athleticfacility": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/soccerstadium.json
// module id = 974
// module chunks = 0